import { render, staticRenderFns } from "./QType1Group.vue?vue&type=template&id=1ffec84c&scoped=true&"
import script from "./QType1Group.vue?vue&type=script&lang=js&"
export * from "./QType1Group.vue?vue&type=script&lang=js&"
import style0 from "./QType1Group.vue?vue&type=style&index=0&id=1ffec84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffec84c",
  null
  
)

export default component.exports